export default {

  getRegularizacaoFundiaria (codigo) {
    switch (codigo) {
      case 'NAO_ONEROSO':
        return 'Não Onerosa'
      case 'ONEROSO':
        return 'Onerosa'
      default:
        return '-'
    }
  },

  getTipoFormatado (codigo) {
    switch (codigo) {
      case 'NAO_ONEROSO':
        return 'Não Oneroso'
      case 'ONEROSO':
        return 'Oneroso'
      case 'PEAS':
        return 'PEAS'
      case 'PEAEX':
        return 'PEAEX'
      case 'CERTIDAO_TITULO':
        return 'Certidão de Título'
      case 'TEQ':
        return 'TEQ'
      case 'PERMUTA':
        return 'Permuta'
      case 'AFORAMENTO':
        return 'Aforamento'
      case 'TRANSFERENCIA_DIREITOS':
        return 'Transferência de Direitos'
      case 'INFORMACOES':
        return 'Informação'
      case 'AREAS_PATRIMONIAIS':
        return 'Áreas Patrimoniais'
      case 'PEAS_FILHO':
        return 'Peas Filho'
      default:
        return '-'
    }
  },
  getStatusFormatado (codigo) {
    switch (codigo) {
      case 'AGUARDANDO_ANALISE':
        return 'Aguardando Análise'
      case 'FINALIZADO':
        return 'Finalizado'
      case 'EM_ANALISE':
        return 'Em Análise'
      case 'TITULADO':
        return 'Titulado'
      case 'ARQUIVADO':
        return 'Arquivado'
      case 'VENCIDO':
        return 'Vencido'
      case 'AGUARDANDO_CALCULO_CUSTAS':
        return 'Aguardando cálculo das custas'
      case 'AGUARDANDO_BOLETO':
        return 'Aguardando emissão do boleto'
      case 'AGUARDANDO_VALIDACAO':
        return 'Aguardando validação'
      case 'EM_ARQUIVAMENTO':
        return 'Em arquivamento'
      case 'EM_RETIFICACAO':
        return 'Em retificação'
      case 'EM_REVISAO':
        return 'Em Revisão'
      case 'AGUARDANDO_ARQUIVAMENTO':
        return 'Aguardando arquivamento'
      case 'AGUARDANDO_ENTREGA':
        return 'Aguardando entrega'
      case 'EM_CONFERENCIA_TITULO':
        return 'Em conferência do título'
      case 'EM_EMISSAO_TITULO':
        return 'Em emissão do título'
      case 'AGUARDANDO_PAGAMENTO_DESARQUIVAMENTO':
        return 'Aguardando pagamento do boleto de desarquivamento'
      case 'AGUARDANDO_GERACAO_DOCUMENTOS':
        return 'Aguardando geração de documentos'
      case 'AGUARDANDO_ATUALIZACAO_BASE':
        return 'Aguardando atualização base'
      case 'AGUARDANDO_CALCULO_VTN':
        return 'Aguardando cálculo do VTN'
      case 'AGUARDANDO_ANALISE_AUTOMATIZADA':
        return 'Aguardando análise automatizada'
      case 'AGUARDANDO_ANALISE_DISTRIBUICAO':
        return 'Aguardando análise distribuição'
      case 'AGUARDANDO_ANALISE_DOCUMENTAL':
        return 'Aguardando análise documental'
      case 'AGUARDANDO_ANALISE_FINAL':
        return 'Aguardando análise final'
      case 'AGUARDANDO_ANALISE_GEO':
        return 'Aguardando análise geo'
      case 'AGUARDANDO_ANALISE_VISTORIA':
        return 'Aguardando análise de vistoria'
      case 'AGUARDANDO_ASSINATURA':
        return 'Aguardando assinatura'
      case 'AGUARDANDO_CONFERENCIA_TITULO':
        return 'Aguardando conferência do título'
      case 'AGUARDANDO_EMISSAO_OFICIO':
        return 'Aguardando emissão de ofício'
      case 'AGUARDANDO_EMISSAO_TITULO':
        return 'Aguardando emissão do título'
      case 'AGUARDANDO_ENTREGA_TITULO':
        return 'Aguardando entrega do título'
      case 'AGUARDANDO_GERACAO_DOCUMENTOS_EM_ANALISE':
        return 'Aguardando geração de documentos em análise'
      case 'AGUARDANDO_VALIDACAO_DOCUMENTAL':
        return 'Aguardando validação documental'
      case 'AGUARDANDO_VALIDACAO_FINAL':
        return 'Aguardando validação da análise final'
      case 'EM_ANALISE_DOCUMENTAL':
        return 'Em análise documental'
      case 'EM_ANALISE_DRF':
        return 'Em análise DRF'
      case 'EM_ANALISE_FINAL':
        return 'Em análise final'
      case 'EM_ANALISE_GEO':
        return 'Em análise geo'
      case 'EM_ANALISE_PESQUISA_SPU':
        return 'Em análise Pesquisa SPU'
      case 'EM_ANALISE_PORTARIA':
        return 'Em análise de portaria'
      case 'EM_ANALISE_VALIDACAO_GEO':
        return 'Em análise validação geo'
      case 'EM_ANALISE_VISTORIA':
        return 'Em análise de vistoria'
      case 'EM_DECISAO':
        return 'Em decisão'
      case 'EM_EMISSAO_OFICIO':
        return 'Em emissão de ofício'
      case 'EM_ENTREGA_TITULO':
        return 'Em entrega de título'
      case 'EM_RETIFICACAO_EM_ANALISE':
        return 'Em retificação em análise'
      case 'EM_REVISAO_DOCUMENTAL':
        return 'Em revisão documental'
      case 'PROCESSO_DEFERIDO':
        return 'Processo deferido'
      case 'PROCESSO_INDEFERIDO':
        return 'Processo indeferido'
      case 'AGUARDANDO_DOCUMENTOS_INTERESSADO':
        return 'Aguardando documentos do interessado'
      case 'AGUARDANDO_VALIDACAO_DOCUMENTOS':
        return 'Aguardando validação dos documentos'
      default:
        return 'Status desconhecido'
    }
  },
  getCodigoFormatado (codigo) {
    switch (codigo) {
      case 'NAO_ONEROSO':
        return 'Não Oneroso'
      case 'ONEROSO':
        return 'Oneroso'
      case 'PEAS':
        return 'PEAS'
      case 'PEAEX':
        return 'PEAEX'
      case 'CERTIDAO_TITULO':
        return 'Certidão de Título'
      case 'TEQ':
        return 'TEQ'
      case 'PERMUTA':
        return 'Permuta'
      case 'AFORAMENTO':
        return 'Aforamento'
      case 'TRANSFERENCIA_DIREITOS':
        return 'Transferência de Direitos'
      case 'INFORMACOES':
        return 'Informação'
      case 'AREAS_PATRIMONIAIS':
        return 'Áreas Patrimoniais'
      default:
        return '-'
    }
  },

  getOutrosFormatado (codigo) {
    switch (codigo) {
      case 'MUNICIPIOS_PARA':
        return 'Municípios Pará'
      default:
        return '-'
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/EnumFormatter.js